import React, { memo } from 'react';

import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { PopperOffset, PopperPlacementType } from 'constants/popover';

const slotProps = placement => ({
  tooltip: {
    sx: {
      backgroundColor: ({ palette }) => palette.background.primary,
      color: ({ palette }) => palette.text.primary,
      borderRadius: ({ shape }) => shape.radius.l,
      boxShadow: ({ palette }) => palette.shadow.m,
      padding: 1.5,
    },
  },
  popper: {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: PopperOffset[placement],
        },
      },
    ],
  },
  arrow: {
    sx: {
      color: ({ palette }) => palette.background.primary,
    },
  },
});

const PopTipCDS = ({ children, ...props }) => (
  <Tooltip slotProps={slotProps(props.placement)} {...props}>
    {children}
  </Tooltip>
);

PopTipCDS.propTypes = {
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(Object.values(PopperPlacementType)),
};

export default memo(PopTipCDS);
